/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { useRef, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import getString from '../../lib/strings/get-string';
export default (function () {
  var strings = useSelector(function (_ref) {
    var strings = _ref.digitalCore.strings;
    return strings;
  });

  var _getString = useCallback(function (stringId) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return getString({
      strings: strings,
      stringId: stringId,
      params: params
    });
  }, [strings]);

  var result = useRef({
    strings: strings,
    getString: _getString
  });
  useEffect(function () {
    result.current = {
      strings: strings,
      getString: _getString
    };
  }, [_getString, strings]);
  return result.current;
});